const parseImageFile = (src) => {
  return `<p><img src="${src}" class="img-resizable"></p>`;
};

const parseNonImageFile = (src, label, mimeType) => {
  return `<p><span src="${src}" label="${label}" file-type="${mimeType}" class="inline-attachment"></span></p>`;
};

const fileToTiptap = (fileUrl, fileName, mimeType) => {
  const isImage = mimeType.split('/')[0] === 'image';
  if (isImage) return parseImageFile(fileUrl);
  return parseNonImageFile(fileUrl, fileName, mimeType);
};

export default function(attachments) {
  if (!attachments || !attachments.length) return '';
  const header = '<br><h3>📎 Fichiers attachés</h3>';
  const attachmentsToDom = attachments
    .map(({ name, url, mimeType }) => fileToTiptap(url, name, mimeType))
    .join('');
  return `${header}${attachmentsToDom}`;
}
